export default "__VITE_ASSET__CeL5r81Y__"